import { getValidDomain } from '../../../shared-functions/DomiansplitFunction';
import getToken from '../../helpers';

export interface HeaderOptions {
  skipGuestToken?: boolean;
  skipAuth?: boolean;
}

/**
 * Default headers for auth
 * @param options Options to control header generation
 * @returns Default headers object or null
 */
const defaultHeaders = (options?: HeaderOptions) => {
  const accessToken = getToken();
  const headers: Record<string, string> = {};
  if (accessToken && !options?.skipAuth) {
    headers.Authorization = accessToken.startsWith('Bearer ')
      ? accessToken
      : `Bearer ${accessToken}`;
    if (!options?.skipGuestToken) {
      headers['Guest-Token'] = accessToken;
    }
  }
  const domain = getValidDomain();
  if (domain) {
    headers.domain = domain;
  }

  return Object.keys(headers).length > 0 ? headers : null;
};

export default defaultHeaders;
